import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Button } from "@/components/ui/button";
import { ScrollArea } from "@/components/ui/scroll-area";
import { format } from "date-fns";

type Conversation = {
  id: string;
  title: string;
  createdAt: string;
};

interface ConversationListProps {
  onSelectConversation: (id: string) => void;
  onNewChat: () => void;
  currentConversationId?: string;
}

export const ConversationList = ({
  onSelectConversation,
  onNewChat,
  currentConversationId,
}: ConversationListProps) => {
  const [conversations, setConversations] = useState<Conversation[]>([]);

  useEffect(() => {
    const fetchConversations = async () => {
      const { data, error } = await supabase
        .from("Conversation")
        .select("*")
        .order("createdAt", { ascending: false });

      if (error) {
        console.error("Error fetching conversations:", error);
        return;
      }

      setConversations(data || []);
    };

    fetchConversations();
  }, []);

  return (
    <div className="w-64 border-r h-full flex flex-col">
      <div className="p-4 border-b">
        <Button onClick={onNewChat} className="w-full">
          New Chat
        </Button>
      </div>
      <ScrollArea className="flex-1">
        <div className="p-2 space-y-2">
          {conversations.map((conversation) => (
            <Button
              key={conversation.id}
              variant={currentConversationId === conversation.id ? "secondary" : "ghost"}
              className="w-full justify-start text-left"
              onClick={() => onSelectConversation(conversation.id)}
            >
              <div className="truncate">
                <div className="font-medium truncate">{conversation.title}</div>
                <div className="text-xs text-muted-foreground">
                  {format(new Date(conversation.createdAt), "MMM d, yyyy")}
                </div>
              </div>
            </Button>
          ))}
        </div>
      </ScrollArea>
    </div>
  );
};